/**
 * Body accessories: vietnamese-misc
 */
import * as THREE from 'three';

export function buildAcc_boyscout_badge(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // HUY HIỆU ĐỘI VIÊN / HOA SEN / SAO VÀNG SẮC SẢO
  const starYellowMat = new THREE.MeshBasicMaterial({ color: '#facc15' });
  const badgeRedMat = new THREE.MeshStandardMaterial({ color: '#b91c1c', roughness: 0.6 });
  const goldTrimMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.85 });
  lib.disposables.push(starYellowMat, badgeRedMat, goldTrimMat);

  // Đế huy hiệu hình khiên đỏ thắm
  const badgeBaseGeo = new THREE.BoxGeometry(0.09, 0.11, 0.015);
  const badgeBase = new THREE.Mesh(badgeBaseGeo, badgeRedMat);
  badgeBase.position.set(-torsoW * 0.26, torsoH * 0.72, torsoD * 0.515);
  accGroup.add(badgeBase);

  // Viền kim loại mạ vàng quanh huy hiệu
  const trimGeo = new THREE.BoxGeometry(0.1, 0.12, 0.012);
  const trim = new THREE.Mesh(trimGeo, goldTrimMat);
  trim.position.set(-torsoW * 0.26, torsoH * 0.72, torsoD * 0.512);
  accGroup.add(trim);

  // Ngôi sao vàng / Hoa sen 5 cánh nổi khối sắc nét
  const starCrossGeo = new THREE.BoxGeometry(0.065, 0.022, 0.02);
  const starCross = new THREE.Mesh(starCrossGeo, starYellowMat);
  starCross.position.set(-torsoW * 0.26, torsoH * 0.72, torsoD * 0.525);
  accGroup.add(starCross);

  const starVertGeo = new THREE.BoxGeometry(0.022, 0.065, 0.02);
  const starVert = new THREE.Mesh(starVertGeo, starYellowMat);
  starVert.position.set(-torsoW * 0.26, torsoH * 0.72, torsoD * 0.525);
  accGroup.add(starVert);

  const starDiagGeo = new THREE.BoxGeometry(0.045, 0.045, 0.022);
  const starDiag = new THREE.Mesh(starDiagGeo, starYellowMat);
  starDiag.position.set(-torsoW * 0.26, torsoH * 0.72, torsoD * 0.525);
  starDiag.rotation.z = Math.PI / 4;
  accGroup.add(starDiag);

  lib.disposables.push(badgeBaseGeo, trimGeo, starCrossGeo, starVertGeo, starDiagGeo);
}

export function buildAcc_khan_ran(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // KHĂN RẰN NAM BỘ: ca-rô đen trắng ô to, lọc Nearest cho nét sắc (không nhoè thành mảng xám)
  const ranCanvas = document.createElement('canvas');
  ranCanvas.width = 64;
  ranCanvas.height = 64;
  const rCtx = ranCanvas.getContext('2d');
  rCtx.fillStyle = '#f5f5f4';
  rCtx.fillRect(0, 0, 64, 64);
  rCtx.fillStyle = '#18181b';
  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < 4; j++) {
      if ((i + j) % 2 === 0) rCtx.fillRect(i * 16, j * 16, 16, 16);
    }
  }
  // Sọc mảnh xen ô như vải khăn rằn thật
  rCtx.fillStyle = 'rgba(24,24,27,0.55)';
  for (let k = 0; k < 4; k++) {
    rCtx.fillRect(k * 16 + 7, 0, 2, 64);
    rCtx.fillRect(0, k * 16 + 7, 64, 2);
  }
  const ranTex = new THREE.CanvasTexture(ranCanvas);
  ranTex.colorSpace = THREE.SRGBColorSpace;
  ranTex.magFilter = THREE.NearestFilter;
  ranTex.minFilter = THREE.NearestFilter;
  ranTex.generateMipmaps = false;
  lib.disposables.push(ranTex);
  const ranMat = new THREE.MeshStandardMaterial({ map: ranTex, roughness: 0.85 });
  lib.disposables.push(ranMat);

  // Vòng khăn quấn quanh cổ áo (ngay dưới đầu, bao 4 mặt thân trên)
  const bandH = 0.07;
  const bandY = torsoH - bandH / 2;
  const ringParts = [
    [torsoW + 0.03, bandH, 0.03, 0, torsoD / 2 + 0.015],
    [torsoW + 0.03, bandH, 0.03, 0, -(torsoD / 2 + 0.015)],
    [0.03, bandH, torsoD + 0.03, torsoW / 2 + 0.015, 0],
    [0.03, bandH, torsoD + 0.03, -(torsoW / 2 + 0.015), 0]
  ];
  ringParts.forEach(([w, h, d, x, z]) => {
    const g = new THREE.BoxGeometry(w, h, d);
    const m = new THREE.Mesh(g, ranMat);
    m.position.set(x, bandY, z);
    accGroup.add(m);
    lib.disposables.push(g);
  });

  // Nút thắt lệch phải & 2 vạt khăn rủ trước ngực
  const knotGeo = new THREE.BoxGeometry(0.08, 0.07, 0.05);
  const knot = new THREE.Mesh(knotGeo, ranMat);
  knot.position.set(torsoW * 0.18, torsoH - 0.09, torsoD / 2 + 0.03);
  accGroup.add(knot);
  const tailGeo = new THREE.BoxGeometry(0.07, torsoH * 0.36, 0.025);
  [
    [-0.22, 0.02],
    [0.28, 0.06]
  ].forEach(([rz, dx]) => {
    const tail = new THREE.Mesh(tailGeo, ranMat);
    tail.position.set(torsoW * 0.18 + dx, torsoH - 0.09 - torsoH * 0.18, torsoD / 2 + 0.028);
    tail.rotation.z = rz;
    accGroup.add(tail);
  });
  lib.disposables.push(knotGeo, tailGeo);
}

export function buildAcc_xe_day_hang_rong(lib, accGroup, torsoW, torsoH, torsoD, opts, handY, sideX) {
  // XE ĐẨY HÀNG RONG / TỦ KÍNH BÁNH MÌ PHỐ CỔ
  const cartGroup = new THREE.Group();
  const inoxMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.8, roughness: 0.2 });
  const glassMat = new THREE.MeshPhysicalMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0.55,
    roughness: 0.1
  });
  const woodMat = new THREE.MeshStandardMaterial({ color: '#78350f', roughness: 0.7 });
  const tireMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.9 });
  const foodMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', roughness: 0.6 }); // Bánh mì / đồ ăn
  lib.disposables.push(inoxMat, glassMat, woodMat, tireMat, foodMat);

  // Xe đứng trên mặt đất bên phải người bán (x dương), chạy dọc trục Z, tay đẩy phía sau
  accGroup.userData.anchor = 'ground';
  cartGroup.position.set(sideX + 0.42, 0, 0.05);

  // 2 Bánh xe cao su
  [-1, 1].forEach((side) => {
    const wheelGeo = new THREE.CylinderGeometry(0.14, 0.14, 0.04, 16);
    const wheel = new THREE.Mesh(wheelGeo, tireMat);
    wheel.rotation.z = Math.PI / 2;
    wheel.position.set(side * 0.31, 0.14, 0.12);
    cartGroup.add(wheel);
    lib.disposables.push(wheelGeo);
  });
  // Chân chống trước
  const legGeo = new THREE.BoxGeometry(0.04, 0.2, 0.04);
  [-0.22, 0.22].forEach((lx) => {
    const leg = new THREE.Mesh(legGeo, inoxMat);
    leg.position.set(lx, 0.1, -0.16);
    cartGroup.add(leg);
  });
  lib.disposables.push(legGeo);

  // Thùng xe inox
  const cartBaseGeo = new THREE.BoxGeometry(0.58, 0.36, 0.5);
  const cartBase = new THREE.Mesh(cartBaseGeo, inoxMat);
  cartBase.position.set(0, 0.38, 0);
  cartBase.castShadow = true;
  cartGroup.add(cartBase);

  // Tủ kính & mái gỗ đựng bánh mì
  const glassCaseGeo = new THREE.BoxGeometry(0.54, 0.34, 0.46);
  const glassCase = new THREE.Mesh(glassCaseGeo, glassMat);
  glassCase.position.set(0, 0.73, 0);
  cartGroup.add(glassCase);
  const roofGeo = new THREE.BoxGeometry(0.6, 0.04, 0.52);
  const roof = new THREE.Mesh(roofGeo, woodMat);
  roof.position.set(0, 0.92, 0);
  cartGroup.add(roof);
  lib.disposables.push(roofGeo);
  [-0.13, 0, 0.13].forEach((fz, i) => {
    const loafGeo = new THREE.BoxGeometry(0.3, 0.07, 0.08);
    const loaf = new THREE.Mesh(loafGeo, foodMat);
    loaf.position.set(i === 1 ? 0.04 : -0.04, 0.6, fz);
    cartGroup.add(loaf);
    lib.disposables.push(loafGeo);
  });

  // Tay đẩy inox phía sau xe
  const pushBarGeo = new THREE.BoxGeometry(0.5, 0.03, 0.03);
  const pushBar = new THREE.Mesh(pushBarGeo, inoxMat);
  pushBar.position.set(0, 0.62, 0.36);
  cartGroup.add(pushBar);
  const armGeo = new THREE.BoxGeometry(0.03, 0.03, 0.14);
  [-0.24, 0.24].forEach((ax) => {
    const arm = new THREE.Mesh(armGeo, inoxMat);
    arm.position.set(ax, 0.6, 0.3);
    arm.rotation.x = 0.25;
    cartGroup.add(arm);
  });
  lib.disposables.push(armGeo);

  accGroup.add(cartGroup);
  lib.disposables.push(cartBaseGeo, glassCaseGeo, pushBarGeo);
}

export function buildAcc_chum_chia_khoa(lib, accGroup, torsoW, torsoH, _torsoD, _opts, _handY, _sideX) {
  // CHÙM CHÌA KHÓA PHÒNG TRỌ KHỔNG LỒ (Vòng khuyên kim loại giắt hông)
  const ringMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.9, roughness: 0.1 });
  const goldKeyMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.85, roughness: 0.2 });
  const silverKeyMat = new THREE.MeshStandardMaterial({ color: '#94a3b8', metalness: 0.8, roughness: 0.2 });
  lib.disposables.push(ringMat, goldKeyMat, silverKeyMat);

  // Vòng tròn khuyên chìa khóa
  const ringGeo = new THREE.TorusGeometry(0.065, 0.012, 8, 16);
  const ring = new THREE.Mesh(ringGeo, ringMat);
  ring.position.set(torsoW * 0.52, torsoH * 0.12, 0);
  ring.rotation.y = Math.PI / 2;
  accGroup.add(ring);

  // 4 chiếc chìa khóa buông thõng lệch góc
  const keyConfigs = [
    { rotZ: -0.15, len: 0.14, mat: goldKeyMat },
    { rotZ: 0.1, len: 0.12, mat: silverKeyMat },
    { rotZ: -0.35, len: 0.16, mat: goldKeyMat },
    { rotZ: 0.28, len: 0.13, mat: silverKeyMat }
  ];

  keyConfigs.forEach((k, idx) => {
    const keyStemGeo = new THREE.BoxGeometry(0.018, k.len, 0.01);
    const keyStem = new THREE.Mesh(keyStemGeo, k.mat);
    keyStem.position.set(torsoW * 0.52 + idx * 0.005, torsoH * 0.12 - k.len * 0.55, (idx - 1.5) * 0.02);
    keyStem.rotation.x = k.rotZ;
    accGroup.add(keyStem);

    // Răng chìa khóa
    const toothGeo = new THREE.BoxGeometry(0.018, 0.025, 0.02);
    const tooth = new THREE.Mesh(toothGeo, k.mat);
    tooth.position.set(torsoW * 0.52 + idx * 0.005, torsoH * 0.12 - k.len + 0.015, (idx - 1.5) * 0.02 + 0.01);
    accGroup.add(tooth);

    lib.disposables.push(keyStemGeo, toothGeo);
  });

  lib.disposables.push(ringGeo);
}

export function buildAcc_the_nhan_vien(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // DÂY ĐEO THẺ NHÂN VIÊN VĂN PHÒNG / GEN Z
  const ribbonMat = new THREE.MeshStandardMaterial({ color: '#0284c7', roughness: 0.6 });
  const badgeMat = new THREE.MeshStandardMaterial({ color: '#ffffff', roughness: 0.3 });
  const photoMat = new THREE.MeshStandardMaterial({ color: '#3b82f6', roughness: 0.4 });
  lib.disposables.push(ribbonMat, badgeMat, photoMat);

  // Dây dù chữ V buông từ cổ xuống ngực
  [-1, 1].forEach((side) => {
    const ribbonGeo = new THREE.BoxGeometry(0.025, torsoH * 0.55, 0.015);
    const ribbon = new THREE.Mesh(ribbonGeo, ribbonMat);
    ribbon.position.set(side * 0.07, torsoH * 0.7, torsoD * 0.515);
    ribbon.rotation.z = -side * 0.22;
    accGroup.add(ribbon);
    lib.disposables.push(ribbonGeo);
  });

  // Tấm thẻ nhựa trắng
  const cardGeo = new THREE.BoxGeometry(0.12, 0.16, 0.015);
  const card = new THREE.Mesh(cardGeo, badgeMat);
  card.position.set(0, torsoH * 0.36, torsoD * 0.52);
  accGroup.add(card);

  // Ô ảnh thẻ màu xanh
  const photoGeo = new THREE.BoxGeometry(0.06, 0.06, 0.018);
  const photo = new THREE.Mesh(photoGeo, photoMat);
  photo.position.set(0, torsoH * 0.39, torsoD * 0.52);
  accGroup.add(photo);

  lib.disposables.push(cardGeo, photoGeo);
}

export function buildAcc_bo_dam_giat_lung(lib, accGroup, torsoW, torsoH, _torsoD, _opts, _handY, _sideX) {
  // BỘ ĐÀM BẢO VỆ GIẮT THẮT LƯNG
  const radioMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.8 });
  const antennaMat = new THREE.MeshStandardMaterial({ color: '#09090b', roughness: 0.5 });
  const buttonMat = new THREE.MeshStandardMaterial({ color: '#ea580c', roughness: 0.4 });
  lib.disposables.push(radioMat, antennaMat, buttonMat);

  // Thân máy bộ đàm
  const radioGeo = new THREE.BoxGeometry(0.09, 0.16, 0.06);
  const radio = new THREE.Mesh(radioGeo, radioMat);
  radio.position.set(-torsoW * 0.54, torsoH * 0.22, 0);
  accGroup.add(radio);

  // Ăng-ten thẳng đứng
  const antennaGeo = new THREE.CylinderGeometry(0.008, 0.008, 0.18, 6);
  const antenna = new THREE.Mesh(antennaGeo, antennaMat);
  antenna.position.set(-torsoW * 0.54, torsoH * 0.22 + 0.17, -0.01);
  accGroup.add(antenna);

  // Nút PTT màu cam bên sườn
  const btnGeo = new THREE.BoxGeometry(0.015, 0.04, 0.02);
  const btn = new THREE.Mesh(btnGeo, buttonMat);
  btn.position.set(-torsoW * 0.54 - 0.048, torsoH * 0.24, 0);
  accGroup.add(btn);

  lib.disposables.push(radioGeo, antennaGeo, btnGeo);
}

export const vietnamese_misc_acc_builders = {
  boyscout_badge: buildAcc_boyscout_badge,
  khan_ran: buildAcc_khan_ran,
  xe_day_hang_rong: buildAcc_xe_day_hang_rong,
  chum_chia_khoa: buildAcc_chum_chia_khoa,
  the_nhan_vien: buildAcc_the_nhan_vien,
  bo_dam_giat_lung: buildAcc_bo_dam_giat_lung
};
